import classes from './style/project.module.css'
import { useHistory } from 'react-router-dom';

const Project = ({ project }) => {
    const history = useHistory();
    const clickHandeler = () => {
        history.push(`/projectdetails/${project.id}`)
    }
    return (
        <div className={classes.projectContainer} onClick={clickHandeler}>
            <img src={project.img} alt='project' />
        </div>
    )
}

export default Project
